var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading[_vm.loadingId] && (!_vm.data || _vm.data.length == 0))?_c('div',[_c('alert',{attrs:{"type":"warning"}},[_vm._v(_vm._s(_vm._f("translate")(_vm.text)))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36bf6e9e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/noRecords.vue
// module id = 220
// module chunks = 0